<div class="container-fluid">
  <form #trForm="ngForm">
    <div class="row top10 no-gutters">
      <div class="col-xs-12 col-lg-4 vcenter">
        <h3>Travel Request: #{{tr.travelRequestId || 'New'}}</h3>
      </div>
      <div class="col-xs-12 col-lg-8 vcenter-right">
        <div class="btn-group" role="group" aria-label="...">
          <button type="button"
                  class="btn btn-default btn-sm"
                  title="Cancel input changes"
                  *ngIf="(!isCancelled() && !isSubmitted())"
                  [disabled]="!(trForm.form.dirty)"
                  (click)="cancelInput()">
            <i class="fas fa-ban"></i>&nbsp;Cancel Input
          </button>
          <button type="button"
                  class="btn btn-default btn-sm"
                  title="Save changes ONLY!"
                  *ngIf="(!isCancelled() && !isSubmitted())"
                  [disabled]="!(trForm.form.valid && verifyAtLeastOneLeg())"
                  (click)="saveTravelRequest()">
            <i class="fas fa-save"></i>&nbsp;Save
          </button>
          <button type="button"
                  class="btn btn-default btn-sm"
                  title="Save & Submit for Approval"
                  *ngIf="(!isCancelled() && !isSubmitted() && !isNew())"
                  [disabled]="!(trForm.form.valid || trForm.form.dirty)"
                  (click)="submitTR()">
            {{calcSubmitText()}}&nbsp;<i class="fas fa-arrow-right"></i>
          </button>
          <button type="button"
                  class="btn btn-default btn-sm"
                  title="Charter's and out-of-state travel requires Step 2 Approval!"
                  [disabled]="step2ApprovalReq() && !permissions.canUpdate(permissions.ComponentID.TravelStep2Approval)"
                  *ngIf="(!isCancelled() &&
                          isSubmitted() &&
                          !isApproved() &&
                          (permissions.canUpdate(permissions.ComponentID.TravelStep1Approval) ||
                            permissions.canUpdate(permissions.ComponentID.TravelStep2Approval)))"
                  (click)="saveTravelRequest()">
            <i class="fas fa-thumbs-up"></i>&nbsp;Approve
          </button>
          <button type="button"
                  class="btn btn-default btn-sm"
                  title="Changes the status to 'Quote Only' and send out a email internally and to Travel Agency!"
                  *ngIf="(!(isCancelled() || isQuoteOnly() || isConfirmed() || isSent()) &&
                            (
                              (isApproved() && permissions.canUpdate(permissions.ComponentID.SendTravelEmails)) ||
                              (permissions.canUpdate(permissions.ComponentID.SendTravelEmails) &&
                                (permissions.canUpdate(permissions.ComponentID.TravelStep1Approval) ||
                                 permissions.canUpdate(permissions.ComponentID.TravelStep2Approval)))
                            )
                          )"
                  [disabled]="!(trForm.form.valid)"
                  (click)="sendQuoteOnlyTravelRequestEmail()">
            <i class="fas fa-envelope"></i>&nbsp;Quote Only
          </button>
          <button type="button"
                  class="btn btn-default btn-sm"
                  title="Send out a email internally ONLY!"
                  *ngIf="(!(isCancelled())  &&
                            (
                              (isApproved() && permissions.canUpdate(permissions.ComponentID.SendTravelEmails)) ||
                              (isSubmitted() && !isApproved() && permissions.canUpdate(permissions.ComponentID.SendTravelEmails) &&
                                (permissions.canUpdate(permissions.ComponentID.TravelStep1Approval) || permissions.canUpdate(permissions.ComponentID.TravelStep2Approval)))
                            )
                          )"
                  [disabled]="!(trForm.form.valid || trForm.form.dirty)"
                  (click)="sendTravelRequestInternal()">
            <i class="fas fa-envelope"></i>&nbsp;Send-Internal
          </button>
          <button type="button"
                  class="btn btn-default btn-sm"
                  title="Mark 'Sent' and send out a email internally and to Travel Agency!"
                  *ngIf="(!(isCancelled() || isSent()) &&
                            (
                              (isApproved() && permissions.canUpdate(permissions.ComponentID.SendTravelEmails)) ||
                              (isSubmitted() && !isApproved() && permissions.canUpdate(permissions.ComponentID.SendTravelEmails) &&
                                (permissions.canUpdate(permissions.ComponentID.TravelStep1Approval) || permissions.canUpdate(permissions.ComponentID.TravelStep2Approval)))
                            )
                          )"
                  (click)="sendTravelRequestExternal()">
            <i class="fas fa-envelope"></i>&nbsp;Send-External
          </button>
          <button type="button"
                  class="btn btn-default btn-sm"
                  title="Changes the status to 'Confirmation'!"
                  *ngIf="(isApproved() && isSent() && !(isCancelled() || isConfirmed() || isQuoteOnly()))"
                  (click)="confirmTravelRequest()">
            <i class="fas fa-thumbs-up"></i>&nbsp;Confirm
          </button>
          <button type="button"
                  class="btn btn-default btn-sm"
                  title="Changes the status to 'Change', must be re-submitted and approved!"
                  *ngIf="(!isNew() &&
                            (
                              (permissions.canUpdate(permissions.ComponentID.Scheduler) && isTraveler()) ||
                              permissions.canUpdate(permissions.ComponentID.SchedulerFunction) ||
                              permissions.canUpdate(permissions.ComponentID.TravelStep1Approval) ||
                              permissions.canUpdate(permissions.ComponentID.TravelStep2Approval)
                            )
                          )"
                  (click)="changeTR()">
            <i class="fas fa-save"></i>&nbsp;Change
          </button>&nbsp;
          <button type="button"
                  [matMenuTriggerFor]="menu"
                  class="btn btn-default btn-sm"
                  title="Changes the status to 'Cancellation' and send out a email!"
                  *ngIf="(!isNew() && !isCancelled() &&
                            (
                              (permissions.canUpdate(permissions.ComponentID.Scheduler) && isTraveler()) ||
                              permissions.canUpdate(permissions.ComponentID.SchedulerFunction) ||
                              permissions.canUpdate(permissions.ComponentID.TravelStep1Approval) ||
                              permissions.canUpdate(permissions.ComponentID.TravelStep2Approval)
                            )
                          )"
          >
            <i class="fas fa-ban"></i>&nbsp;Cancel TR
          </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="cancelTR(true)" >
                <mat-icon>email</mat-icon>
                <span>Cancel TR with email</span>
              </button>
              <button mat-menu-item (click)="cancelTR(false)" >
                <mat-icon>cancel</mat-icon>
                <span>Cancel TR with NO email</span>
              </button>
            </mat-menu>
          <button type="button"
                  class="btn btn-default btn-sm"
                  title="Print Travel Request"
                  *ngIf="(!isNew())"
                  [disabled]="(!(trForm.form.valid) || tr.travelRequestId == 0)"
                  (click)="printTR()">
            <i class="fas fa-print"></i>&nbsp;Print
          </button>
        </div>
      </div>
    </div>
    <hr style="margin-top:2px;margin-bottom:12px" />

    <div class="row" style="margin-bottom: 10px">
      <div class="col-xs-12">
        <aims-form [editable]="calculateEditable() && !isSubmitted()" [cols]="3" [spaceRows]="false">
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field appearance="fill">
              <mat-select
                #aimsControl="ngModel"
                [(ngModel)]="tr.travelRequestStatusId"
                name="Status"
                [disabled]="true"
              >
                <mat-option *ngFor="let s of trStatusValues | async" [value]="s.travelRequestStatusId"> {{ s.travelRequestStatus }}</mat-option>
              </mat-select>
            </mat-form-field>
          </aims-fc>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field>
              <mat-label></mat-label>
              <input matInput #aimsControl="ngModel" [matDatepicker]="picker1"
                    name="Requested On"
                    placeholder="mm/dd/yyyy"
                    [(ngModel)]="tr.requestedOn"
                    [disabled]="isSubmitted()"
              >
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
          </aims-fc>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <ng-container *ngIf="tr.employeeId != null">
              <aims-lookup #aimsControl="ngModel"
                           name="Traveler"
                           [gridText]="'Select an Employee'"
                           [values]="employeeValues | async"
                           [idPropertyName]="'employeeId'"
                           [displayPropertyName]="'fullName'"
                           [(ngModel)]="tr.employeeId"
                           [columnsInGrid]="employeeLookupColumns"
                           [disabled]="isSubmitted()"
                           required>
              </aims-lookup>
            </ng-container>
            <ng-container *ngIf="tr.employeeId == null">
              <aims-lookup #aimsControl="ngModel"
                           name=" Traveler"
                           [gridText]="'Select a Resource'"
                           [values]="resourceValues | async"
                           [idPropertyName]="'resourceId'"
                           [displayPropertyName]="'fullName'"
                           [(ngModel)]="tr.resourceId"
                           [columnsInGrid]="resourceLookupColumns"
                           [disabled]="isSubmitted()"
                           required>
              </aims-lookup>
            </ng-container>
          </aims-fc>
        </aims-form>

        <aims-form [editable]="false" [cols]="3" [spaceRows]="true">
          <aims-fc [labelColSize]="5" [controlColSize]="7">
             <mat-form-field appearance="fill">
              <mat-select
                #aimsControl="ngModel"
                name="Requested By"
                [(ngModel)]="tr.requestedById"
                [disabled]="true"
              >
                <mat-option *ngFor="let e of emps" [value]="e.employeeId"> {{ e.fullName }}</mat-option>
              </mat-select>
            </mat-form-field>
          </aims-fc>
          <ng-container *ngIf="tr.submittedOn != null">
            <aims-fc [labelColSize]="5" [controlColSize]="7">
                 <mat-form-field>
              <mat-label></mat-label>
              <input matInput #aimsControl="ngModel" [matDatepicker]="picker2"
                    name="Submitted On"
                    placeholder="mm/dd/yyyy"
                    [(ngModel)]="tr.submittedOn"
                    required
              >
              <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
            </aims-fc>
          </ng-container>
          <ng-container *ngIf="tr.approvedById != null">
            <aims-fc [labelColSize]="5" [controlColSize]="7">
              <mat-form-field appearance="fill">
                <mat-select
                  #aimsControl="ngModel"
                  name="Approved By"
                  [(ngModel)]="tr.approvedById"
                  [disabled]="true"
                >
                  <mat-option *ngFor="let e of emps" [value]="e.employeeId"> {{ e.fullName }}</mat-option>
                </mat-select>
              </mat-form-field>
            </aims-fc>
          </ng-container>
        </aims-form>

        <aims-form [editable]="false" [cols]="3" [spaceRows]="true">
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field appearance="fill">
              <input matInput
                  #aimsControl="ngModel"
                  name="Travel Weight"
                  type="text"
                  [(ngModel)]="tr.travelWeight"
                  disabled />
            </mat-form-field>
          </aims-fc>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-checkbox appearance="fill"
                  #aimsControl="ngModel"
                  name="Military Transport Auth"
                  [(ngModel)]="tr.militaryTransportAuthorized"
                  tabindex="-1">
            </mat-checkbox>
          </aims-fc>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-checkbox appearance="fill"
                  #aimsControl="ngModel"
                  name="Sent-Travel Agent & Travel Coord."
                  [(ngModel)]="tr.sentToTravelAgent"
                  tabindex="-1">
            </mat-checkbox>
          </aims-fc>
        </aims-form>

        <aims-form [editable]="calculateEditable() && !isSubmitted()" [cols]="1" [header]="'Itinerary'" [spaceRows]="true">
          <aims-fc>
          <aims-common-table
                  name="Leg Table"
                  id="leg-table"
                  [dataSource]="tr.schTravelRequestLegs"
                  [defaultTableState] = "{ sort:{ active : 'travelLeg', direction: 'asc' }}"
                  [header]="legTableHeader"
                  [permissions]="legTablePermissions"
                  [pageSize]="10"
                  [addRowInitialObject]="defaultTrLegs"
                  (rowUpdated)="handleLegRowUpdate($event)"
                  (rowAdded)="handleLegRowAdd($event)"
                  (rowDeleted)="handleLegRowDelete($event)"
                  [stickyHeader]="true">
            <aims-common-table-dynamic-row id="travelFromId">
              <ng-template viewMode let-element >
                {{ element.travelFromId | getText:'siteId':'siteName':siteValues | async }}
              </ng-template>

              <ng-template editMode let-element let-dynamicControl="dynamicControl">
                <mat-form-field appearance="fill" class="form-component" class="editable-text-field">
                  <mat-select style="width: 100px" [formControl]="dynamicControl" name="travelFromId">
                    <mat-option *ngFor="let s of siteValues | async" [value]="s.siteId">
                            {{ s.siteName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-template>
            </aims-common-table-dynamic-row>

             <aims-common-table-dynamic-row id="travelToId">
              <ng-template viewMode let-element >
                {{ element.travelToId | getText:'siteId':'siteName':siteValues | async }}
              </ng-template>

              <ng-template editMode let-element let-dynamicControl="dynamicControl">
                <mat-form-field appearance="fill" class="form-component" class="editable-text-field">
                  <mat-select style="width: 100px" [formControl]="dynamicControl" name="travelToId">
                    <mat-option *ngFor="let s of siteValues | async" [value]="s.siteId">
                            {{ s.siteName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-template>
            </aims-common-table-dynamic-row>

            <aims-common-table-dynamic-row id="travelOn">
              <ng-template viewMode let-element >
                <ng-container *ngIf="element.travelOn == null">
                  OPEN
                </ng-container>
                <ng-container *ngIf="element.travelOn != null">
                  {{element.travelOn | date: 'mediumDate'}}
                </ng-container>
              </ng-template>
              <ng-template editMode let-element let-dynamicControl="dynamicControl">
               <mat-form-field style="margin-top: 10px;">
                <mat-label></mat-label>
                <input name="travelOn" matInput (dateChange)="updateTravelOn($event.value)"  [formControl]="dynamicControl" [matDatepicker]="picker1" placeholder="mm/dd/yyyy" >
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
              </mat-form-field>
              </ng-template>
            </aims-common-table-dynamic-row>

            <aims-common-table-dynamic-row id="departId">
              <ng-template viewMode let-element >
                {{ element.departId | getText:'departAndArriveTypeId':'departAndArriveType':departAndArriveValues | async }}
              </ng-template>

              <ng-template editMode let-element let-dynamicControl="dynamicControl">
                <mat-form-field appearance="fill" class="form-component" class="editable-text-field">
                  <mat-select style="width: 100px" [formControl]="dynamicControl" name="departId">
                    <mat-option *ngFor="let d of departAndArriveValues | async" [value]="d.departAndArriveTypeId">
                            {{ d.departAndArriveType }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-template>
            </aims-common-table-dynamic-row>

            <aims-common-table-dynamic-row id="arriveId">
              <ng-template viewMode let-element >
                {{ element.arriveId | getText:'departAndArriveTypeId':'departAndArriveType':departAndArriveValues | async }}
              </ng-template>

              <ng-template editMode let-element let-dynamicControl="dynamicControl">
                <mat-form-field appearance="fill" class="form-component" class="editable-text-field">
                  <mat-select style="width: 100px" [formControl]="dynamicControl" name="arriveId">
                    <mat-option *ngFor="let d of departAndArriveValues | async" [value]="d.departAndArriveTypeId">
                            {{ d.departAndArriveType }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-template>
            </aims-common-table-dynamic-row>

            <aims-common-table-dynamic-row id="travelerTypeId">
              <ng-template viewMode let-element >
                {{ element.travelerTypeId | getText:'travelerTypeId':'travelerType':travelerTypeValues | async }}
              </ng-template>

              <ng-template editMode let-element let-dynamicControl="dynamicControl">
                <mat-form-field appearance="fill" class="form-component" class="editable-text-field">
                  <mat-select style="width: 100px" [formControl]="dynamicControl" name="travelerTypeId">
                    <mat-option *ngFor="let t of activeTravelerTypeValues | async" [value]="t.travelerTypeId">
                            {{ t.travelerType }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-template>
            </aims-common-table-dynamic-row>

            <aims-common-table-dynamic-row id="taskCodeId">
              <ng-template viewMode let-element >
                {{ element.taskCodeId | getText:'taskCodeId':'taskCode':taskCodeValues | async }}
              </ng-template>

              <ng-template editMode let-element let-dynamicControl="dynamicControl">
                <mat-form-field appearance="fill" class="form-component" class="editable-text-field">
                  <mat-select style="width: 100px" [formControl]="dynamicControl" name="taskCodeId">
                    <mat-option *ngFor="let t of taskCodeValues | async" [value]="t.taskCodeId">
                            {{ t.taskCode }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-template>
            </aims-common-table-dynamic-row>

            <aims-common-table-dynamic-row id="oanumber">
              <ng-template viewMode let-element >
                {{ element.oanumber | getText:'oanumber':'oaTask' :oaNumberValues | async }}
              </ng-template>

              <ng-template editMode let-element let-dynamicControl="dynamicControl">
                <mat-form-field appearance="fill" class="form-component" class="editable-text-field">
                  <mat-select style="width: 100px" [formControl]="dynamicControl" name="oanumber">
                    <mat-option *ngFor="let t of oaNumberValues | async" [value]="t.oanumber">
                            {{ t.oaTask }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-template>
            </aims-common-table-dynamic-row>

            <aims-common-table-dynamic-row id="scheduleItemId">
              <ng-template viewMode let-element >
                <div *ngIf="element.scheduleItemId">
                  <a style="text-decoration:underline;cursor:pointer" [routerLink]="'/scheduling/' + element.scheduleItemId.toString()" target="_blank">
                    {{ element.scheduleItemId | getText:'scheduleItemId':'siDescription':siWithoutTrData }}</a>
                </div>
              </ng-template>

              <ng-template editMode let-element let-dynamicControl="dynamicControl">
                <aims-lookup
                             [formControl]="dynamicControl"
                             name="ScheduleItemId"
                             id="scheduleItemId"
                             class="fullWidth"
                             [gridText]="'Select a Schedule Item'"
                             [values]="siWithoutTrData"
                             [idPropertyName]="'scheduleItemId'"
                             [displayPropertyName]="'siDescription'"
                             [columnsInGrid]="scheduleItemLookupColumns"
                             [disabled]="isSubmitted()"
                             required>
                </aims-lookup>
              </ng-template>
            </aims-common-table-dynamic-row>
          </aims-common-table>

          </aims-fc>
        </aims-form>

        <aims-form [editable]="calculateEditable() && !isSubmitted()" [cols]="3" [header]="'Authorizations'" [spaceRows]="true">
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-checkbox appearance="fill"
                  #aimsControl="ngModel"
                  name="Non-Refundable Ticket from Anchorage/Fairbanks"
                  [(ngModel)]="tr.nonRefundableAuth"
                  [disabled]="isSubmitted()"
                  tabindex="-1">
            </mat-checkbox>
          </aims-fc>

          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-checkbox appearance="fill"
                  #aimsControl="ngModel"
                  name="Charter"
                  title="Charter's require Step 2 Approval!"
                  [(ngModel)]="tr.charter"
                  [disabled]="isSubmitted()"
                  tabindex="-1">
            </mat-checkbox>
          </aims-fc>
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field appearance="fill">
            <input matInput #aimsControl="ngModel"
                   [(ngModel)]="tr.groundTime"
                   name="Ground Time (Hours)"
                   [disabled]="isSubmitted()" />
            </mat-form-field>
          </aims-fc>
        </aims-form>

        <aims-form [editable]="calculateEditable() && !isSubmitted()" [cols]="3" [spaceRows]="true">
          <aims-fc [labelColSize]="5" [controlColSize]="7">
            <mat-form-field appearance="fill" *ngIf="isSubmitted()">
              <mat-select #aimsControl="ngModel"
                [(ngModel)]="tr.lodgingAuthTypeId"
                name="Lodging"
                disabled="true"
              >
                <mat-option *ngFor="let l of lodgingAuthTypeValues | async" [value]="l.lodgingAuthTypeId"> {{ l.lodgingAuthType }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" *ngIf="!isSubmitted()">
              <mat-select #aimsControl="ngModel"
                [(ngModel)]="tr.lodgingAuthTypeId"
                name="Lodging"
              >
                <mat-option *ngFor="let l of activeLodgingAuthTypeValues | async" [value]="l.lodgingAuthTypeId"> {{ l.lodgingAuthType }}</mat-option>
              </mat-select>
            </mat-form-field>
          </aims-fc>

          <aims-fc [labelColSize]="5" [controlColSize]="7">

            <mat-form-field appearance="fill" *ngIf="isSubmitted()">
              <mat-select #aimsControl="ngModel"
                name="Rental Car"
                [(ngModel)]="tr.rentalCarAuthTypeId"
                disabled="true"
              >
                <mat-option *ngFor="let r of rentalCarAuthTypeValues | async" [value]="r.rentalCarAuthTypeId"> {{ r.rentalCarAuthType }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" *ngIf="!isSubmitted()">
              <mat-select #aimsControl="ngModel"
                name="Rental Car"
                [(ngModel)]="tr.rentalCarAuthTypeId"
              >
                <mat-option *ngFor="let r of activeRentalCarAuthTypeValues | async" [value]="r.rentalCarAuthTypeId"> {{ r.rentalCarAuthType }}</mat-option>
              </mat-select>
            </mat-form-field>

          </aims-fc>

          <aims-fc [labelColSize]="5" [controlColSize]="7">

            <mat-form-field appearance="fill" *ngIf="isSubmitted()">
              <mat-select #aimsControl="ngModel"
                name="Flight"
                [(ngModel)]="tr.flightAuthTypeId"
                disabled="true"
              >
                <mat-option *ngFor="let r of flightAuthTypeValues | async" [value]="r.flightAuthTypeId"> {{ r.flightAuthType }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" *ngIf="!isSubmitted()">
              <mat-select #aimsControl="ngModel"
                name="Flight"
                [(ngModel)]="tr.flightAuthTypeId"
              >
                <mat-option *ngFor="let r of activeFlightAuthTypeValues | async" [value]="r.flightAuthTypeId"> {{ r.flightAuthType }}</mat-option>
              </mat-select>
            </mat-form-field>

          </aims-fc>
        </aims-form>

        <aims-form [editable]="calculateEditable() && !isSubmitted()" [cols]="1" [header]="'Baggage'" [spaceRows]="true">
          <aims-fc>
          <aims-common-table
                  name="Baggage Table"
                  id="baggage-table"
                  [dataSource]="tr.schTravelRequestBags"
                  [header]="baggageTableHeader"
                  [permissions]="baggageTablePermissions"
                  [pageSize]="10"
                  [addRowInitialObject]="defaultTrBags"
                  (rowUpdated)="handleBaggageRowUpdate($event)"
                  (rowAdded)="handleBaggageRowAdd($event)"
                  (rowDeleted)="handleBaggageRowDelete($event)"
                  [stickyHeader]="true">

            <aims-common-table-dynamic-row id="travelRequestBagTypeId">
              <ng-template viewMode let-element >
                {{ element.travelRequestBagTypeId | getText:'travelRequestBagTypeId':'travelRequestBagType':travelRequestBagTypeValues | async }}
              </ng-template>

              <ng-template editMode let-element let-dynamicControl="dynamicControl">
                <mat-form-field appearance="fill" class="form-component" class="editable-text-field">
                  <mat-select style="width: 100px" [formControl]="dynamicControl" name="travelRequestBagTypeId">
                    <mat-option *ngFor="let t of travelRequestBagTypeValues | async" [value]="t.travelRequestBagTypeId"> {{ t.travelRequestBagType }} </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-template>
            </aims-common-table-dynamic-row>
          </aims-common-table>

         </aims-fc>
        </aims-form>

        <aims-form [editable]="calculateEditable() && !isSubmitted()" [cols]="1" [header]="'Comments/Special Instructions'" [spaceRows]="true">
          <mat-form-field appearance="fill" style="width:100%">
            <textarea matInput #aimsControl="ngModel"
                    rows="4"
                    class="fullWidth"
                    [(ngModel)]="tr.travelRequestComments"
                    name="Comments/Special Instructions"
                    [disabled]="isSubmitted()"
                    maxlength="500">
            </textarea>
          </mat-form-field>
        </aims-form>

        <aims-form [editable]="false" [cols]="1" [header]="'Additional Notes'" [spaceRows]="true">
          <aims-fc>
            Normal travel from either Anchorage or Fairbanks to a site (or hub) will be made 14 days in advance and will be on a non-refundable ticket. Scheduled changes not initiated by the company will be paid for by the employee. Unless otherwise indicated above, the Company will pay for no more than 200 lbs of personal luggage. This will be in 4 or fewer bags each weighing 50 lbs or less, with dimensions of less than 62 linear inches (length + height + Width). Any charges for bags exceeding these criteria, or for more than 4 bags, will be paid by the employee at the ticket counter.
          </aims-fc>
        </aims-form>

      </div>
    </div>
  </form>
  <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>
</div>
